import { catalog, plural } from '@nolens/i18n';

/** Estatísticas de um espaço: leituras por dia, por origem, os mais lidos e a poupança. */
export const statsText = catalog(
  {
    title: 'Statistics',
    hint: 'How the guides in this space are being read, in the last 30 days.',
    spaceNotFound: 'Space not found.',
    reads30: 'Reads in 30 days',
    readsTotal: 'Reads since the start',
    guides: 'Guides in the space',
    timeSaved: 'Time saved',
    estimate: 'estimate',
    seeSavings: 'Savings by month and person',
    perDay: 'Reads per day',
    perDayHint: 'Last 30 days',
    chartLabel: (max: number) => `Reads per day in the last 30 days, up to ${max} a day`,
    reads: (n: number) => `${n} ${plural('en', n, { one: 'read', other: 'reads' })}`,
    dayLabel: (day: string, n: number, member: number, pub: number, embed: number) =>
      `${day}: ${n} ${plural('en', n, { one: 'read', other: 'reads' })} (team ${member}, public link ${pub}, embed ${embed})`,
    team: 'Team',
    publicLink: 'Public link',
    embed: 'Embed',
    bySource: 'By source',
    asTable: 'See as a table',
    day: 'Day',
    total: 'Total',
    top: 'Most read',
    topHint: 'Reads in the last 30 days and since the start.',
    allTime: (n: number) => `${n} since the start`,
    noReads: 'No reads yet. When someone opens a guide in this space, it counts here.',
    untitled: 'Untitled',
  },
  {
    'pt-PT': {
      title: 'Estatísticas',
      hint: 'Como estão a ser lidos os guias deste espaço, nos últimos 30 dias.',
      spaceNotFound: 'Espaço não encontrado.',
      reads30: 'Leituras em 30 dias',
      readsTotal: 'Leituras desde o início',
      guides: 'Guias no espaço',
      timeSaved: 'Tempo poupado',
      estimate: 'estimativa',
      seeSavings: 'Poupança por mês e por pessoa',
      perDay: 'Leituras por dia',
      perDayHint: 'Últimos 30 dias',
      chartLabel: (max) => `Leituras por dia nos últimos 30 dias, até ${max} por dia`,
      reads: (n) => `${n} ${plural('pt-PT', n, { one: 'leitura', other: 'leituras' })}`,
      dayLabel: (day, n, member, pub, embed) =>
        `${day}: ${n} ${plural('pt-PT', n, { one: 'leitura', other: 'leituras' })} (equipa ${member}, ligação pública ${pub}, embed ${embed})`,
      team: 'Equipa',
      publicLink: 'Ligação pública',
      embed: 'Embed',
      bySource: 'Por origem',
      asTable: 'Ver como tabela',
      day: 'Dia',
      total: 'Total',
      top: 'Os mais lidos',
      topHint: 'Leituras nos últimos 30 dias e desde o início.',
      allTime: (n) => `${n} desde o início`,
      noReads: 'Ainda não há leituras. Quando alguém abrir um guia deste espaço, conta aqui.',
      untitled: 'Sem título',
    },
  },
);
